import { filterByLocation } from "../filters";
import { GreenhouseDepartment } from "../types";

const getAvailableDepartmentNames = (departments: GreenhouseDepartment[], selectedLocationName: string) => {
  if (!departments?.length) {
    return [];
  }

  const departmentNames = new Set<string>();
  const availableDepartments = departments.filter(filterByLocation(selectedLocationName));

  availableDepartments.forEach((department) => {
    if (department?.jobs?.length > 0) {
      departmentNames.add(department.name);
    }
  });

  return Array.from(departmentNames);
};

export { getAvailableDepartmentNames };
